const DEFAULT_SELECTORS = {
  expMonth: '#id_exp_month',
  expYear: '#id_exp_year',
  cardNum: '#id_card',
  cvv: '#id_cvv',
}

export const useBraintree = defineStore('braintree', () => {
  const { $axios } = useNuxtApp()
  const clientToken = ref(null)
  const clientInstance = ref(null)
  const hostedFieldsInstance = ref(null)

  async function getClientInstance(selectors = DEFAULT_SELECTORS) {
    if (!clientToken.value) {
      const resp = await $axios.get('/api/payment/card-token/')
      clientToken.value = resp.data.token
    }
    if (clientInstance.value) {
      return clientInstance.value
    }
    const braintree = await import('braintree-web')
    clientInstance.value = await braintree.client.create({
      authorization: clientToken.value,
    })
    return clientInstance.value
  }

  function resetBraintree() {
    clientToken.value = null
    clientInstance.value = null
    if (hostedFieldsInstance.value) {
      hostedFieldsInstance.value.teardown()
      hostedFieldsInstance.value = null
    }
  }

  async function getHostedFieldsInstance(
    excludeCardNumber,
    styles,
    selectors = DEFAULT_SELECTORS,
  ) {
    await getClientInstance()

    const options = {
      client: clientInstance.value,
      styles: {
        'input,select': {
          color: 'rgba(0, 0, 0, 0.45)',
          'font-size': '12.5px',
          'font-family': 'europa, sans-serif',
          padding: '0.3125rem 0',
          '-webkit-appearance': 'none',
          outline: 'none',
        },
        '.invalid': {
          color: 'red',
        },
        '.valid': {
          color: 'inherit',
        },
        ':focus': {
          color: 'inherit',
        },
      },
      fields: {
        expirationMonth: {
          container: selectors.expMonth,
          placeholder: '',
          select: true,
        },
        expirationYear: {
          container: selectors.expYear,
          placeholder: '',
          select: true,
        },
      },
    }

    if (!excludeCardNumber) {
      options.fields.number = {
        container: selectors.cardNum,
        placeholder: '',
      }
    }

    options.fields.cvv = {
      container: selectors.cvv,
      placeholder: '',
    }

    const braintree = await import('braintree-web')
    hostedFieldsInstance.value = await braintree.hostedFields.create(options)
    return hostedFieldsInstance.value
  }

  return {
    clientToken,
    clientInstance,
    hostedFieldsInstance,
    getClientInstance,
    getHostedFieldsInstance,
    resetBraintree,
  }
})
